import { gql } from "@apollo/client";

// One department with its members and leads, for TeamEditDialog: saving
// the dialog sends who was added or removed, so it has to start from the
// saved ones.
export default gql`
  query getOrganizationTeamQuery($teamId: Int!) {
    team(teamId: $teamId) {
      id
      title
      leads {
        id
        name
        avatar
      }
      members(orderBy: "name") {
        totalCount
        edges {
          node {
            id
            name
            avatar
          }
        }
      }
    }
  }
`;
